import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';

import { DRNInputField } from '@traveloka/district-ui';
import DRNCheckbox from 'common/components/Checkbox/Checkbox';

import AuthorizeView from 'common/components/AuthorizeView/AuthorizeView';
import { BOOK_ON_BEHALF_PERMISSION } from 'common/constants/authPermissionConstants';
import Modal from 'common/components/Modal/Modal';
import TouchableInputFieldWrapper from 'common/components/TouchableInputFieldWrapper/TouchableInputFieldWrapper';
import Collapsible from 'react-native-collapsible';
import R from 'common/res/R';
import BusAgentAutoCompleteContainer from '../../containers/BusAgentAutoComplete';

class BusBookOnBehalfField extends PureComponent {
  state = {
    openAgentAutocomplete: false,
  };

  constructor(props) {
    super(props);

    this.handleCloseAgentAutocomplete = this.handleCloseAgentAutocomplete.bind(
      this
    );
    this.handleOpenAgentAutocomplete = this.handleOpenAgentAutocomplete.bind(
      this
    );
    this.handleSetBookOnBehalf = this.handleSetBookOnBehalf.bind(this);
  }

  async handleCloseAgentAutocomplete({ agentId }) {
    this.setState({ openAgentAutocomplete: false });

    if (agentId) {
      this.props.onSelectAgent();
    }
  }

  handleOpenAgentAutocomplete() {
    this.setState({ openAgentAutocomplete: true });
  }

  handleSetBookOnBehalf() {
    this.props.setBookOnBehalf(!this.props.bookOnBehalf);
  }

  render() {
    const { openAgentAutocomplete } = this.state;
    const { bookOnBehalf, bookOnBehalfAgentName } = this.props;
    return (
      <AuthorizeView.RequiredAll
        requiredPermission={[BOOK_ON_BEHALF_PERMISSION]}
      >
        <View>
          <DRNCheckbox
            label="Saya pesan untuk agen lain"
            labelStyle={styles.checkboxLabel}
            value={bookOnBehalf}
            onChange={this.handleSetBookOnBehalf}
          />
        </View>

        <Collapsible style={styles.bookOnBehalfField} collapsed={!bookOnBehalf}>
          <TouchableInputFieldWrapper
            onPress={this.handleOpenAgentAutocomplete}
          >
            <DRNInputField
              label={bookOnBehalfAgentName || 'Cari nama agen'}
              style={styles.bookOnBehalfInput}
              editable={false}
            />
          </TouchableInputFieldWrapper>
        </Collapsible>

        <Modal isVisible={openAgentAutocomplete} style={{ margin: 0 }}>
          <BusAgentAutoCompleteContainer
            onClose={this.handleCloseAgentAutocomplete}
          />
        </Modal>
      </AuthorizeView.RequiredAll>
    );
  }
}

const styles = StyleSheet.create({
  checkboxLabel: {
    fontSize: R.typography.fontSize.small,
  },
  bookOnBehalfField: {
    paddingBottom: R.spacing.s,
    paddingHorizontal: R.spacing.m,
    marginBottom: R.spacing.xs,
  },
  bookOnBehalfInput: {
    ...R.typography.weightBold,
    fontColor: R.color.uiLightPrimary,
  },
});

export default BusBookOnBehalfField;
